import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { FinanceDtoKeysEnum } from '@zaoblako/shared/modules/finance/enums/finance-dto-keys.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { KktFindDto, type KktFindInterface } from '@zaoblako/shared/modules/finance/dtos/kkt/kkt-find.dto';

import * as yup from 'yup';

export const DEFAULT_COLUMNS = [
  'operator',
  'contragent',
  'revenue',
  'receiptCount',
  'lastReceiptDate',
] as const;

/** Kkts list APIs base filters */
export interface KktFiltersInterface {
  /** Identifiers of concrete kkts to take */
  ids?: number[];
  /** Identifiers of kkt owner operators */
  operatorIds?: number[];
  /** Identifiers of kkt owner contragents */
  contragentIds?: number[];
  /** Registration numbers of kkt */
  regNumbers?: string[];
  /** Sorting settings */
  sort?: string;
  /** Kkt dates period start */
  from?: Date;
  /** Kkt dates period end */
  to?: Date;
  /** Sorting settings */
  sortSums?: string;
  /** show deleted kkts */
  withDeleted?: boolean;
  /** Search from KKT fiscal storage or registration number */
  search?: string;
  /** Selected columns to includes */
  select?: (keyof KktFindInterface)[];
}

/** Kkts list APIs base filters - DTO schema */
export const KktFiltersDto = SerdeDtoClass.create<KktFiltersInterface>(
  FinanceDtoKeysEnum.KKT_FILTERS_DTO,
  {
    ids: {
      optional: true,
      label: 'Номера касс',
      serializer: yup.array(
        yup
          .number()
          .positive(DtoMessageEnum.NOT_POSITIVE)
          .integer(DtoMessageEnum.NOT_INTEGER),
      ),
    },
    operatorIds: {
      optional: true,
      label: 'Номера операторов ОФД',
      serializer: yup.array(
        yup
          .number()
          .positive(DtoMessageEnum.NOT_POSITIVE)
          .integer(DtoMessageEnum.NOT_INTEGER),
      ),
    },
    from: {
      optional: true,
      label: 'Начало периода',
      serializer: yup.date(),
    },
    to: {
      optional: true,
      label: 'Конец периода',
      serializer: yup.date(),
    },
    contragentIds: {
      optional: true,
      label: 'Номера контрагентов',
      serializer: yup.array(
        yup
          .number()
          .positive(DtoMessageEnum.NOT_POSITIVE)
          .integer(DtoMessageEnum.NOT_INTEGER),
      ),
    },
    sort: {
      optional: true,
      label: 'Сортировка',
      serializer: SerdeDtoClass.getSortingCriteriaValidator(KktFindDto),
    },
    sortSums: {
      optional: true,
      label: 'Сортировка подытогов',
      serializer: yup.string(),
    },
    withDeleted: {
      optional: true,
      label: 'Показывать удалённые',
      serializer: yup.boolean(),
    },
    search: {
      optional: true,
      label: 'Поиск',
      serializer: yup.string(),
    },
    select: {
      optional: true,
      label: 'Выбрать поля',
      serializer: SerdeDtoClass.getSelectablePropertiesValidator(KktFindDto),
    },
  },
);
